import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { PurchaseShell } from "../features/purchase/PurchaseShell";
import { NeuButton, NeuCard, NeuInput } from "../components/neu/Neu";
import { getPurchaseSettings, savePurchaseSettings } from "../api/purchases";

const FIELDS = ["manager_limit", "hr_limit", "price_tolerance_percent", "quantity_tolerance_percent",
                "ap_account", "input_vat_account", "payment_account"];

export default function PurchaseSettingsPage() {
  const { t } = useTranslation();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getPurchaseSettings().then(setForm).catch(() => setForm(null));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      setForm(await savePurchaseSettings(form));
      toast.success(t("purchases.settingsSaved"));
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <PurchaseShell titleKey="settings">
      {!form ? null : (
        <NeuCard className="grid gap-3 p-5" data-testid="purchase-settings">
          <p className="label-xs">{t("purchases.settingsTitle")}</p>
          <p className="text-xs text-muted-foreground">{t("purchases.settingsHint")}</p>
          <div className="grid gap-3 sm:grid-cols-2">
            {FIELDS.map((key) => (
              <label key={key} className="grid gap-1 text-[11px] font-bold text-muted-foreground">
                {t(`purchases.settings.${key}`)}
                <NeuInput data-testid={`purchase-setting-${key}`} dir="ltr" value={form[key] ?? ""}
                          onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
              </label>
            ))}
          </div>
          <label className="flex items-center gap-2 text-xs font-bold">
            <input type="checkbox" data-testid="purchase-setting-require-receipt"
                   checked={!!form.require_receipt_before_bill}
                   onChange={(e) => setForm({ ...form, require_receipt_before_bill: e.target.checked })} />
            {t("purchases.settings.require_receipt_before_bill")}
          </label>
          <NeuButton variant="primary" data-testid="purchase-settings-save" disabled={busy} onClick={save}>
            {t("purchases.saveSettings")}
          </NeuButton>
        </NeuCard>
      )}
    </PurchaseShell>
  );
}
